import config from '../../config/config';

import deleteRequest from './base/delete';
import getRequest from './base/get';
import patchRequest from './base/patch';
import postRequest from './base/post';

interface QueryParameters {
  limit?: number;
  [key: string]: any;
}

interface RoleParameters {
  name: string;
  responsibility: string;
  permissions: (string | number)[];
  platformPermissions?: (string | number)[];
}

export default {
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  fetchRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/roles`, { ...parameters });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchRolesFilterList: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/list-filters`);
  },
  /**
   * Fetch the Accounts list with pagination
   * @param {any} query - The query
   */
  exportRoles: (query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/export-roles`, {
      ...parameters,
    });
  },
  /**
   * Fetch the Accounts list with pagination
   */
  fetchAllRoles: (): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/role-names`, {});
  },
  /**
   * Fetch the permissions list
   */
  fetchAllPermissions: (): Promise<any> => {
    return getRequest(
      `${config.subscription.accountApiUrl}api/common/v1/roles/permissions-list`,
      {},
    );
  },
  /**
   * Create the role api call function
   * @param {any} data - The role configuration parameters
   * @returns {any} A promise that resolves with the creation response
   */
  createRoles: (
    data: RoleParameters = {
      name: '',
      responsibility: '',
      permissions: [],
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return postRequest(`${config.subscription.accountApiUrl}api/common/v1/roles`, {
      ...parameters,
    });
  },
  /**
   * Update the role api call function
   * @param {any} id - The role ID to edit
   * @param {any} data - The updated role parameters
   * @returns {any} A promise that resolves with the update response
   */
  editRoles: (
    id: string,
    data: RoleParameters = {
      name: '',
      responsibility: '',
      permissions: [],
    },
  ): Promise<any> => {
    const parameters = { ...data };
    return patchRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/${id}`, {
      ...parameters,
    });
  },
  /**
   * Update the role api call function
   * @param {any} id - The role ID to fetch
   * @returns {any} A promise that resolves with the role details
   */
  fetchRoleById: (id: string): Promise<any> => {
    return getRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/${id}`);
  },
  /**
   * Delete role api call function
   * @param {any} id - The role ID to delete
   * @returns {any} A promise that resolves with the deletion response
   */
  deleteRoles: (id: string): Promise<any> => {
    return deleteRequest(`${config.subscription.accountApiUrl}api/common/v1/roles/${id}`);
  },
  /**
   * Fetch all roles dropdown
   * @param {any} role - The role name
   * @returns {any} A promise that resolves with the roles dropdown
   */
  fetchAllRolesDropdown: (role: string): Promise<any> => {
    return getRequest(
      `${config.subscription.accountApiUrl}api/cpo/v1/roles/list-by-permission?productPermission=${role}`,
    );
  },
};
